import { Component } from '@angular/core';

@Component({
  selector: 'administration',
  templateUrl: 'administration.component.html',
  styleUrls: ['administration.component.css'],
})
export class AdministrationComponent {

  selectedItem: number = 0;

  constructor() {
  }
  itemSelected(index: number) {
    this.selectedItem = index;
  }

}
